import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import convertKeys from 'convert-keys';
import copyIcon from 'assets/icons/copy-orange.svg';
import JSONUtils from '@mm/state/helpers/json-utils';
import { RefTextInput } from './RefTextInput';
import { JSONCodeTextArea } from './JSONCodeTextArea';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { CopyOutlined, InfoCircleFilled } from '@ant-design/icons';

type Props = {
  code: string;
  refString: string;
  usedInSlideout?: boolean;
};

export const ManualSync = ({ code, refString, usedInSlideout }: Props) => (
  <div className="messenger-ad-detail-sync__manual-sync">
    <div className="ad-detail__note">
      <InfoCircleFilled className="ad-detail__info-circle" />
      <div className="ad-detail__subtext">
        Use the manual option if you want to create multiple Messenger Ad setups
        and apply them within the same campaign. Follow steps below then copy
        and paste the JSON and URL Parameters into the Facebook Ads manager as
        outlined in the help doc.
      </div>
    </div>
    <div className="messenger-ad-detail__url-block">
      <RefTextInput text={`ref=${refString}`} usedInSlideout={usedInSlideout} />
      <CopyToClipboard text={`ref=${refString}`}>
        <PrimaryButton className="messenger-ad-detail__manual-sync-copy-button">
          <CopyOutlined className="messenger-ad-detail__copy-icon" />
          Copy
        </PrimaryButton>
      </CopyToClipboard>
    </div>
    <div className="messenger-ad-detail__json-block">
      <JSONCodeTextArea
        code={JSON.stringify(convertKeys.toSnake(code), undefined, 4)}
        usedInSlideout={usedInSlideout}
      />
      <div>
        <CopyToClipboard text={JSONUtils.toString(convertKeys.toSnake(code))}>
          <PrimaryButton className="messenger-ad-detail__manual-sync-copy-button">
            <CopyOutlined className="messenger-ad-detail__copy-icon" />
            Copy
          </PrimaryButton>
        </CopyToClipboard>
      </div>
    </div>
  </div>
);
